module.exports = __webpack_public_path__ + "img/button_heart.32b69593.svg";